export const STATUS = {
  draft: { id: 'Draf', en: 'Draft', cls: 'bg-slate-100 text-slate-700' },
  scheduled: { id: 'Terjadwal', en: 'Scheduled', cls: 'bg-amber-100 text-amber-800' },
  sending: { id: 'Mengirim', en: 'Sending', cls: 'bg-sky-100 text-sky-800' },
  ab_waiting: { id: 'Menunggu A/B', en: 'A/B waiting', cls: 'bg-violet-100 text-violet-800' },
  sent: { id: 'Terkirim', en: 'Sent', cls: 'bg-emerald-100 text-emerald-800' },
  cancelled: { id: 'Dibatalkan', en: 'Cancelled', cls: 'bg-rose-100 text-rose-700' },
  failed: { id: 'Gagal', en: 'Failed', cls: 'bg-rose-100 text-rose-700' },
};

export const LOG_STATUS = {
  queued: { id: 'Antrean', en: 'Queued', cls: 'bg-slate-100 text-slate-700' },
  sent: { id: 'Terkirim', en: 'Sent', cls: 'bg-sky-100 text-sky-800' },
  delivered: { id: 'Sampai', en: 'Delivered', cls: 'bg-emerald-100 text-emerald-800' },
  opened: { id: 'Dibuka', en: 'Opened', cls: 'bg-violet-100 text-violet-800' },
  clicked: { id: 'Diklik', en: 'Clicked', cls: 'bg-fuchsia-100 text-fuchsia-800' },
  bounced: { id: 'Bounce', en: 'Bounced', cls: 'bg-rose-100 text-rose-700' },
  complained: { id: 'Komplain', en: 'Complained', cls: 'bg-rose-100 text-rose-700' },
  failed: { id: 'Gagal', en: 'Failed', cls: 'bg-rose-100 text-rose-700' },
};

export const CATEGORIES = [
  { value: 'promo', id: 'Promo', en: 'Promo' },
  { value: 'newsletter', id: 'Newsletter', en: 'Newsletter' },
  { value: 'announcement', id: 'Pengumuman', en: 'Announcement' },
  { value: 'transactional', id: 'Transaksional', en: 'Transactional' },
];

export const SOURCES = { manual: 'Manual', import: 'Import CSV', ecommerce: 'E-commerce', sales: 'Sales', website: 'Website' };

export const Pill = ({ map, value, lang }) => {
  const s = map[value] || { id: value, en: value, cls: 'bg-slate-100 text-slate-700' };
  return <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${s.cls}`} data-testid={`pill-${value}`}>{lang === 'id' ? s.id : s.en}</span>;
};

export const fmtDt = (v, lang) => (v ? new Date(v).toLocaleString(lang === 'id' ? 'id-ID' : 'en-GB', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
export const pct = (v) => `${Number(v || 0).toLocaleString('id-ID', { maximumFractionDigits: 1 })}%`;
export const toLocalInput = (d) => { const x = new Date(d.getTime() - d.getTimezoneOffset() * 60000); return x.toISOString().slice(0, 16); };
